<template>
    <a-card>
        <a-form class="table-search" ref="searchForm" layout="inline" :model="searchForm">
            <a-form-item label="项目领域" name="totalAssets">
                <DictSelect v-model:value="searchForm.projectField" :dict-name="innovation.TECHNICAL_FIELD" placeholder="请选择项目领域" />
            </a-form-item>
            <a-form-item>
                <a-button type="primary" @click="onSearch">查询</a-button>
                <a-button @click="onReset">重置</a-button>
            </a-form-item>
        </a-form>
        <div class="table-toolbar">
            <a-button type="primary" @click="onAdd">
                <template #icon>
                    <plus-outlined/>
                </template>
                新增
            </a-button>
            <a-popconfirm title="确认要删除吗?" @confirm="onDeleteBatch(deleteUrl)" v-if="selectedRowKeys.length">
                <a-button danger>批量删除</a-button>
            </a-popconfirm>
        </div>
        <a-alert type="info" showIcon class="table-alert" v-if="selectedRowKeys.length">
            <template #message>
                已选择 {{ selectedRowKeys.length }} 项
                <a @click="onClearSelected" class="ml-20 float-right">清空</a>
            </template>
        </a-alert>
        <a-table
            :columns="columns"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :pagination="pagination"
            :data-source="dataSource"
            :loading="loading"
            @change="onTableChange">
            <template #picture="{record}">
                <div  style="position: relative; width:35px; height:35px; margin: 3px 3px; overflow: hidden;">
                <img-upload style="position: absolute; top:-35px; left:-35px" v-model:value="record.picture" :showList="true" disabled />
                </div>
            </template>
            <template #projectName="{record}">
                <a @click="onDetail(record)">{{record.projectName}}</a>
            </template>
            <template #projectField="{text}">
                <dict-render :dict-obj="dictObjs['technical_field']" :text="text"></dict-render>
            </template>
            <template #publish="{ text }">
                <dict-render :dict-obj="dictObjs['isShow']" :text="text"></dict-render>
            </template>

            <template #action="{record}">
                <div class="table-row-operations">
                    <!--                    <a @click="onStateus(record)">服务状态修改</a>-->
                    <a @click="onEdit(record)">编辑</a>
                </div>
            </template>
        </a-table>
    </a-card>
    <AddOrEditModal ref="modal" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
    <Detail ref="modalDetail" :form-primary-key-field="listKeyField" @finish="onFormEdited"/>
</template>

<script>
import AddOrEditModal from "./components/AddOrEditModal";
import Detail from "./components/Detail";
import {tableListMixin,dictMixin} from "@/mixins";
import {financeProject} from "@/api/finance";
import DictRender from "@/components/other/DictRender";
import {innovation} from "@/config/variableConfig";
import DictSelect from "@/components/other/DictSelect";

const columns = [
    // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
        {title: "项目图片", fixed:'left', dataIndex: "picture", key: "picture", slots: {customRender: "picture"}},
        {title: "项目名称", fixed:'left', dataIndex: "projectName", key: "projectName", slots: {customRender: "projectName"}},
        {title: "项目领域", dataIndex: "projectField", key: "projectField", slots: {customRender: "projectField"}},
        {title: "项目联系人", dataIndex: "contacts", key: "contacts"},
        {title: "联系人电话", dataIndex: "contactNumber", key: "contactNumber"},
        {title: "发布状态", dataIndex: "publish", key: "publish", slots: {customRender: "publish"}},
        {title: "操作", fixed:'right', dataIndex: "action", key: "action", slots: {customRender: "action"}},
];
export default {
    name: "融资需求",
    mixins: [tableListMixin,dictMixin],
    components: {
        AddOrEditModal,
        Detail,
        DictRender,
        DictSelect
    },
    data() {
        return {
          innovation,
            dictNames: 'technical_field,isShow',
            columns,
            queryParam: {},
            listUrl: financeProject.pageList,
            listKeyField: "id",
            deleteUrl: financeProject.remove
        }
    },
    methods: {
        onAdd() {
            this.onShowModal('modal');
        },
        onEdit(record) {
            this.getAction({
                url: financeProject.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modal', res);
            })
        },
        onDetail(record) {
            this.getAction({
                url: financeProject.detail,
                params: {id: record.id}
            }).then(res => {
                this.onShowModal('modalDetail', res);
            })
        },
    }
}
</script>

<style scoped>

</style>
